var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.563653 9.2364C0.212181 8.88492 0.212181 8.31508 0.563653 7.9636L3.52726 5L0.563653 2.0364C0.212181 1.68492 0.212181 1.11508 0.563653 0.763604C0.915125 0.412132 1.48497 0.412132 1.83645 0.763604L5.43645 4.3636C5.78792 4.71508 5.78792 5.28492 5.43645 5.6364L1.83645 9.2364C1.48497 9.58787 0.915125 9.58787 0.563653 9.2364Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.e1a5dfcaa891194c8bac88b722385471.svg";
export { ForwardRef as ReactComponent };